export class ProfileInfo {
    name: string;
    about: string; 

    // copied from firebase database
    designation: string;
    
    email: string; 
    phoneNo: number; 
    profileImageUri: string; 
    isPhoneNumberVisible: boolean; 
    isProfileImageVisible: boolean;

    uuid?: string;

    updatedAt: number;
    updatedAtImage: number;
  }



// WEBPACK FOOTER //
// /app/src/app/core/models/profile-info.ts